export default "__VITE_ASSET__9eafb4eb__"